import React from "react";

const Loader = () => (
  <div className="flex justify-center items-center py-16">
    <div className="fresh-spinner" />
  </div>
);

export default Loader;
